import { presentationsTypes } from "../constantes/actionTypes"

const initialState = []

export const presentations = (state = initialState, action) => {
    switch (action.type) {
        case presentationsTypes.GET_ALL_PRESENTATIONS_SUCCESS:
            return action.payload
        case presentationsTypes.GET_ALL_PRESENTATIONS_FAILURE:
            return initialState
        case presentationsTypes.GET_ALL_PRESENTATIONS_BY_TITLE_PAGED_SUCCESS:
            return state.concat(action.payload)
        case presentationsTypes.NEW_PRESENTATIONS_CONTACT_HOSPITAL_SUCCESS:
            return [...state, action.payload]
        case presentationsTypes.DELETE_PRESENTATIONS_SUCCESS:
            let newState = state.filter(x => x.id_Presentacion !== action.payload)
            return newState
        case presentationsTypes.UPDATE_PRESENTATIONS_SUCCESS:
            const updatePresentation = state.map(item => {
                if(item.id_Presentacion=== action.payload.id_Presentacion){
                    item.isEnviado = true
                    return item
                }
                return item
            })
            return updatePresentation
        case presentationsTypes.CLEAR_PRESENTATIONS_LIST:
            return initialState
        case presentationsTypes.UPDATE_PRESENTATIONS_FAILURE:
        case presentationsTypes.DELETE_PRESENTATIONS_FAILURE:
        case presentationsTypes.NEW_PRESENTATIONS_CONTACT_HOSPITAL_FAILURE:
            return state
        case presentationsTypes.GET_ALL_PRESENTATIONS_BY_TITLE_PAGED_FAILURE:
            return initialState
        default:
            return state
    }
}